import { WaypointCategoryEnum } from "../../enums";
import { IWaypointCategoryVisual } from "./station-route.models";

export const WAYPOINT_CATEGORY_VISUAL = {
  [WaypointCategoryEnum.MLPathWaypoint]: {
    color: "#651fff",
    borderColor: "#7c4dff",
    backgroundColor: "#ede7f6",
    tooltipKey: "stationRoute.waypoint.CATEGORY_ML_PATH_TOOLTIP",
  },
  [WaypointCategoryEnum.CourseWaypoint]: {
    color: "#00a651",
    borderColor: "#00c853",
    backgroundColor: "#e8f5e9",
    tooltipKey: "stationRoute.waypoint.CATEGORY_COURSE_TOOLTIP",
  },
  [WaypointCategoryEnum.RideWaypoint]: {
    color: "#ff6d00",
    borderColor: "#ff9100",
    backgroundColor: "#fff3e0",
    tooltipKey: "stationRoute.waypoint.CATEGORY_RIDE_TOOLTIP",
  },
  [WaypointCategoryEnum.AreaWaypoint]: {
    color: "#c2185b",
    borderColor: "#e91e63",
    backgroundColor: "#f8bbd0",
    tooltipKey: "stationRoute.waypoint.CATEGORY_AREA_TOOLTIP",
  },
} satisfies Record<WaypointCategoryEnum, IWaypointCategoryVisual>;
